import { Button, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import ItemStatus from "../../../../../../common/components/item_status";
import dayjs from "dayjs";

/**
 * GenerateProdutosServicosColumnDefinition
 */

type Props = {
  canDelete: boolean;
  onActionDeletar: (idProdutoServicoEntregue: number, isProduto: boolean) => void;
  onActionDownload: (idProdutoServicoEntregue: number, nomeArquivo: string) => void;
};

export const GenerateProdutosServicosColumnDefinition = ({
  canDelete,
  onActionDeletar,
  onActionDownload,
}: Props): GridColDef[] => {
  const computeTipoTitle = (status: number) => {
    switch (status) {
      case 1:
        return "Produto";
      case 0:
        return "Serviço";
      default:
        return "?";
    }
  };

  const computeTipoColor = (status: number) => {
    switch (status) {
      case 1:
        return "green";
      case 0:
        return "yellow";
      default:
        return "blue";
    }
  };

  const computeTipoDescription = (status: number) => {
    switch (status) {
      case 1:
        return "Produto";
      case 0:
        return "Serviço";
      default:
        return "?";
    }
  };

  return [
    {
      field: "tipo",
      filterable: false,
      headerName: "Tipo",
      minWidth: 80,
      width: 80,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeTipoTitle(params.value === 'P' ? 1 : 0)}
            color={computeTipoColor(params.value === 'P' ? 1 : 0)}
            description={computeTipoDescription(params.value === 'P' ? 1 : 0)} />
        </div>
      )
    },
    {
      field: "numero",
      filterable: false,
      headerName: "Nº",
      minWidth: 70,
      width: 70,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Produto/Serviço",
      flex: 1,
      minWidth: 120,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "nroNotaFiscal",
      filterable: false,
      headerName: "N° NOTA FISCAL",
      minWidth: 90,
      width: 90,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "unidade",
      filterable: false,
      headerName: "Unidade",
      minWidth: 100,
      width: 100,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "quantidade",
      filterable: false,
      headerName: "Quantidade",
      minWidth: 100,
      width: 100,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "quantidadeEntregue",
      filterable: false,
      headerName: "Quantidade entregue",
      minWidth: 100,
      width: 100,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "quantidadeEntregueAcumulada",
      filterable: false,
      headerName: "Quantidade entregue acumulada",
      minWidth: 180,
      width: 180,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "restante",
      filterable: false,
      headerName: "Restante",
      minWidth: 100,
      width: 100,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "dataEntrega",
      filterable: false,
      headerName: "Data da Entrega",
      minWidth: 100,
      width: 100,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            {value && dayjs.utc(value).local().format("DD/MM/YYYY")}
          </div>
        );
      },
    },
    {
      field: "nomeArquivo",
      filterable: false,
      headerName: "Nota",
      minWidth: 120,
      width: 120,
      sortable: false,
      valueGetter: (_, rows) => ({
        nomeArquivo: rows['nomeArquivo'],
        idProdutoServicoEntregue: rows['idProdutoServicoEntregue'],
      }),
      renderCell: (params) => {
        const nomeArquivo = params.value['nomeArquivo'] as string;
        const idProdutoServicoEntregue = params.value['idProdutoServicoEntregue'] as number;
        return (
          <>
            {
              nomeArquivo &&
              <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
                <Button
                  onMouseDown={() => onActionDownload(idProdutoServicoEntregue, nomeArquivo)}
                  sx={{
                    fontSize: 11,
                    paddingX: '.4rem',
                    paddingY: 0,
                    background: '#e6e6e6',
                    borderLeft: '.3rem solid #45b6af',
                    borderRadius: 0,
                    color: 'black',
                    fontWeight: 'normal',
                    width: '6rem',
                  }}>
                  Nota Fiscal
                </Button>
              </div>
            }
          </>
        );
      },
    },
    {
      field: 'idProdutoServicoEntregue',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 60,
      resizable: false,
      renderCell: (params) => {
        if (!canDelete) return null;

        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => { onActionDeletar(params.value, true) }}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}
